import type { SVGProps } from 'react';

const SvgStorageCloud = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M20.91 13.61c-.02-.1-.04-.2-.07-.3-.05-.18-.1-.36-.17-.54-.04-.11-.08-.22-.13-.33-.09-.19-.19-.37-.3-.55-.09-.15-.19-.28-.29-.42-.1-.13-.2-.25-.31-.37-.09-.1-.19-.19-.29-.28-.12-.11-.24-.21-.37-.3-.1-.07-.2-.15-.3-.22-.22-.14-.46-.27-.7-.38.01-.14.02-.28.02-.41 0-3.03-2.47-5.5-5.5-5.5a5.53 5.53 0 0 0-5.22 3.76A5.98 5.98 0 0 0 3 13.5c0 3.31 2.69 6 6 6h7c2.76 0 5-2.24 5-5 0-.3-.04-.6-.09-.89M16 17.5H9c-2.21 0-4-1.79-4-4a3.98 3.98 0 0 1 3.27-3.92c.4-.07.72-.38.8-.78a3.502 3.502 0 0 1 6.93.71c-.88 0-1.74.23-2.5.67-.48.28-.64.89-.36 1.37s.89.64 1.37.36c.45-.26.97-.4 1.5-.4.22 0 .43.03.63.07.28.06.53.17.77.3.07.04.14.07.2.11.09.06.17.12.25.19l.17.14c.08.07.15.15.22.23.05.05.09.11.14.17.06.08.12.17.17.26.04.07.08.14.11.21.04.09.09.17.12.26.04.09.06.19.09.28.02.08.05.15.06.23.03.18.06.37.06.56 0 1.65-1.35 3-3 3z"
    />
  </svg>
);
export default SvgStorageCloud;
